<template>
    <div class="table">
        <!-- 头部 -->
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <!-- 表格内容 -->
        <div class="container">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="活动名称:">
                    <el-input v-model="queryParams.name" placeholder="请输入活动名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态:">
                    <el-select v-model="queryParams.state" placeholder="请选择状态" clearable @change="changeQuery">
                        <el-option label="上线" :value="2"></el-option>
                        <el-option label="下线" :value="1"></el-option>
                        <el-option label="已下架" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <div style="float: right">
                    <el-button type="primary" @click="changeQuery()">搜索</el-button>
                </div>
            </el-form>
            <div class="action">
                <el-button type="primary" @click="add()">新增拼团</el-button>

            </div>
            <el-table v-loading="loading" :data="pageInfo.list" element-loading-text="数据加载中" stripe border ref="multipleTable">
                <el-table-column prop="r" label="排序" width="150" align="center"></el-table-column>
                <el-table-column prop="id" label="id" width="150" align="center"></el-table-column>
                <el-table-column label="活动名称" prop="name" align="center"></el-table-column>
                <el-table-column label="拼团海报" align="center" width="80" prop="poster">
                    <template slot-scope="scope">
                        <el-image @click="showBigImg(scope.$index)" style="height:23px;width:30px;" fit="cover" :class="`column${scope.$index}`" :src="scope.row.poster" :preview-src-list="[scope.row.poster]">
                            <div slot="error" class="image-slot">
                                <el-image fit="cover" :src="defaultImg"></el-image>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label="活动内容" prop="desc" align="center"></el-table-column>
                <el-table-column label="成团人数" prop="number" align="center" width="120"></el-table-column>
                <el-table-column label="开始时间" prop="stime" width="180" align="center"></el-table-column>
                <el-table-column label="结束时间" prop="etime" width="180" align="center"></el-table-column>
                <el-table-column label="成团有效期(小时)" prop="time" width="180" align="center"></el-table-column>
                <el-table-column label="能否使用优惠券" prop="is_coupon" align="center" width="120">
                    <template slot-scope="scope">
                        <el-tag type="info" v-if="scope.row.is_coupon === 1">不可用</el-tag>
                        <el-tag type="primary" v-if="scope.row.is_coupon === 2">可用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="state" align="center" width="80">
                    <template slot-scope="scope">
                        <el-tag type="info" v-if="scope.row.state === 1">下线</el-tag>
                        <el-tag type="primary" v-if="scope.row.state === 2">上线</el-tag>
                        <el-tag type="primary" v-if="scope.row.state === 3">已下架</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="170" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" @click="collageGoods(scope.row.id)">配置商品</el-button>
                        <el-button type="text" icon="el-icon-edit" @click="edit(scope.$index, scope.row)">编辑</el-button>
                        <el-button v-if="scope.row.state === 2" type="text" class="red" @click="state(scope.row, 1)">下线
                        </el-button>
                        <el-button v-if="scope.row.state === 1" type="text" class="green" @click="state(scope.row, 2)">
                            上线</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
        </div>
        <!-- 新增 编辑 -->
        <el-dialog :title="title" :visible.sync="addVisible" width="900px" v-if="addVisible" class="dialog_box">
            <el-form ref="form" :model="form" label-width="130px" :rules="rules" label-position="left">
                <el-form-item label="排序 " prop="r">
                    <el-input v-model="form.r" placeholder="数字越大越靠前" type="number"></el-input>
                </el-form-item>
                <el-form-item label="活动名称" prop="name">
                    <el-input type="text" placeholder="请输入活动名称" v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="活动内容" prop="desc">
                    <el-input type="textarea" placeholder="请输入活动内容" autosize v-model="form.desc" style="width:295px"></el-input>
                </el-form-item>
                <el-form-item label="拼团海报" prop="poster">
                    <el-input v-model="form.poster" placeholder="请输入图片链接"></el-input>
                    <el-button @click.prevent="choiceImg">选择图片</el-button>
                    <el-upload class="avatar-uploader up" :action="IMAGE_UPLOAD_PRO_URL" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" name="file" :headers="header">
                        <img v-if="form.poster" :src="form.poster" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <span class="span_gray">建议尺寸750*1000像素</span>
                </el-form-item>
                <el-form-item label="幻灯片" prop="form">
                    <Imgupload v-model="form.thumbs" :ImgVisible="ImgSwiperVisible" @changeImg="choiceSwiperImg" @changetext="changetext" />
                    <span class="span_gray">建议尺寸750*1125像素,可拖动图片调整位置</span>
                </el-form-item>
                <el-form-item label="成团人数" prop="number">
                    <el-input type="text" placeholder="请输入成团人数" v-model="form.number" :disabled="form.id >0"></el-input>
                    <span class="gray">人</span>
                </el-form-item>
                <el-form-item label="成团有效期" prop="time">
                    <el-input type="text" placeholder="请输入成团有效期" v-model="form.time" :disabled="form.id >0"></el-input>
                    <span class="gray">小时</span>
                    <p style="margin-top: 10px;" class="span_gray">设置用户发起开团到拼团结束的时间，不设置等于活动有效期</p>
                </el-form-item>
                <el-form-item label="起止时间" prop="otime">
                    <el-date-picker ref="drawDate" :picker-options="pickerOptions" style="margin-left: 5px;" v-model="form.otime" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="能否使用优惠券" prop="is_coupon">
                    <el-radio-group v-model="form.is_coupon">
                        <el-radio :label="2">可用</el-radio>
                        <el-radio :label="1">不可用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="状态" prop="state">
                    <el-radio-group v-model="form.state">
                        <el-radio :label="2">上线</el-radio>
                        <el-radio :label="1">下线</el-radio>
                        <el-radio :label="3">已下架</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveData">保 存</el-button>
            </span>
        </el-dialog>
        <!-- 上线、下线提示框 -->
        <el-dialog title="提示" :visible.sync="confirmVisible" width="300px" center>
            <div class="del-dialog-cnt">{{ confirmContent }}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmVisible = false">取 消</el-button>
                <el-button type="primary" @click="stateData">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 选择图片对话框 -->
        <div class="img">
            <Picture :ImgVisible="ImgVisible" @toggleImg="toggleImg" @getImg="getImg"></Picture>
        </div>
        <!-- 选择图片对话框 -->
        <div class="img">
            <Picture :ImgVisible="ImgSwiperVisible" @toggleImg="toggleSwiperImg" @getImg="getSwiperImg"></Picture>
        </div>
    </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb';
import Pagination from '@/components/Pagination';
import loadEvents from '@/utils/loading'
import Url from '@/components/Url';
import { request } from '@/common/request';
import Picture from '@/components/Picture';
import { deal } from '@/common/main';
import {IMAGE_UPLOAD_PRO_URL} from "../../common/const";
import Imgupload from "@/components/Imgupload.vue";
let loads = new loadEvents();
export default {
    name: 'seller',
    components: {
        Imgupload,
        Breadcrumb,
        Pagination,
        Url,
        Picture
    },
    data() {
        return {
            IMAGE_UPLOAD_PRO_URL:IMAGE_UPLOAD_PRO_URL,
            selectList: '',
            ImgVisible: false,
            ImgSwiperVisible: false, //添加 轮播图的显示
            header: {},
            defaultImg: require('../../assets/img/zhan.jpeg'),
            menuList: ['营销', '多人拼团'],
            text: 'image',
            queryParams: {
                page: 1,
                pagesize: 10
            },
            //验证规则
            rules: {
                r: [{
                    required: true,
                    message: '排序不能为空',
                    trigger: 'blur'
                },
                {
                    pattern: '^[0-9]*$',
                    message: "只能输入数字"
                }],
                poster: [{ validator: deal.checkImage, trigger: ['blur', 'change'], required: true, }],
                name: [{
                    required: true,
                    message: '活动名称不能为空',
                    trigger: 'blur'
                }],
                desc: [{
                    required: true,
                    message: '活动内容不能为空',
                    trigger: 'blur'
                }],
                time: [{
                    required: false,
                    trigger: 'blur'
                },
                {
                    pattern: '^[0-9]*$',
                    message: "只能输入数字"
                }],
                number: [{
                    required: true,
                    message: '成团人数不能为空',
                    trigger: 'blur'
                },
                {
                    pattern: '^[0-9]*$',
                    message: "只能输入数字"
                }],
                otime: [{
                    required: true,
                    message: '起止时间不能为空',
                    trigger: 'blur'
                }],
                is_coupon: [{
                    required: true,
                    message: '能否使用优惠券不能为空',
                    trigger: 'blur'
                }],
                state: [{
                    required: true,
                    message: '状态不能为空',
                    trigger: 'blur'
                }],
            },
            loading: false,
            pageInfo: {
            },
            addVisible: false,
            removeVisible: false,
            confirmVisible: false,
            confirmContent: '',
            title: '加载中',
            mode: 'add',
            form: {
                thumbs:[]
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            }
        };
    },
    created() {
        this.header.token = localStorage.getItem('token');
        this.header.platform = 'admin';
        this.loadData();
    },
    methods: {

        toggleImg(val) { // 关闭 img对话框
            this.ImgVisible = val;
        },
        choiceImg() {
            this.ImgVisible = true
        },
        getImg(url) {// 获取选择的img
            this.$set(this.form, 'poster', url);
        },

        toggleSwiperImg(val) { // 关闭 img对话框
            this.ImgSwiperVisible = val;
        },
        choiceSwiperImg() {
            this.ImgSwiperVisible = true
        },
        getSwiperImg(url) {// 获取选择的img
            this.form.thumbs.push(url)
        },

        //分页
        changeQuery() {
            this.queryParams.page = 1;
            this.loadData();
        },
        refreshPageSize(val) {
            this.queryParams.pagesize = val;
            this.loadData();
        },
        refreshPageNum(val) {
            this.queryParams.page = val;
            this.loadData();
        },
        // 查看大图
        showBigImg(index) {
            this.$nextTick(function () {
                let shows = document.getElementsByClassName(`column${index}`)
                let show = shows[0].getElementsByClassName('el-image-viewer__wrapper')
                show[0].style['display'] = 'block'
                let dom = show[0].getElementsByClassName('el-image-viewer__mask')
                dom[0].addEventListener('click', function () {
                    show[0].style['display'] = 'none'
                })
            })
        },
        //图片上传
        beforeAvatarUpload(file) {
            loads.open('.avatar-uploader .el-upload', '上传中')
            const _this = this
            return deal.imageFormat(file, _this, 300)
        },
        handleAvatarSuccess(res, file) {
            if (res.code == 1) {
                loads.close()
                this.$set(this.form, 'poster', res.data.uri);
            }
        },
        //新增
        add() {
            this.mode = 'add';
            this.title = '新增多人拼团';
            this.form = {
                state: 2,
                is_coupon: 2,
                thumbs: []
            };
            this.addVisible = true;
            if (this.$refs.form) {
                this.$refs.form.clearValidate()
            }
        },
        //编辑
        edit(index, row) {
            this.mode = 'edit';
            this.title = '编辑多人拼团';
            this.current = row.id;
            const item = this.pageInfo.list[index];
            let time = [item.stime, item.etime]
            //处理时间
            this.form = Object.assign({}, item);
            this.$set(this.form, 'otime', time);
            this.form.r = this.form.r + ''
            this.form.number = this.form.number + ''
            this.form.time = this.form.time + ''
            this.addVisible = true;
            if (this.$refs.form) {
                this.$refs.form.clearValidate()
            }
        },
        //状态
        state(row, state) {
            if (state == 2) {
                this.confirmContent = '确定是否上线?';
            } else {
                this.confirmContent = '确定是否下线?';
            }
            this.form = Object.assign({}, row);
            this.form.state = state;
            this.form.stime = deal.timestamp(this.form.stime);
            this.form.etime = deal.timestamp(this.form.etime);
            this.confirmVisible = true;
        },
        loadData() {
            // 获取拼团列表
            this.loading = true;
            request.get('/goods/spell/list', this.queryParams).then(ret => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.pageInfo = ret.data;
                    this.pageInfo.list = ret.data.list;
                    this.pageInfo.list.map(function (val) {
                        val.stime = deal.timestamp(val.stime, 'unix');
                        val.etime = deal.timestamp(val.etime, 'unix');
                        return val;
                    })
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        //增加编辑
        saveData() {
            if (this.$refs.form) {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        var url = this.mode == 'add' ? '/goods/spell/add' : '/goods/spell/edit';
                        this.form.stime = deal.timestamp(this.form.otime[0]);
                        this.form.etime = deal.timestamp(this.form.otime[1]);
                        this.form.thumbsJson = JSON.stringify(this.form.thumbs)
                        request.post(url, this.form).then(ret => {
                            if (ret.code == 1) {
                                this.addVisible = false;
                                this.loadData();
                                this.$message.success((this.mode == 'add' ? '新增' : '编辑') +
                                    '成功');
                                this.$refs.form.clearValidate()
                            } else {
                                this.$message.error(ret.msg);
                            }
                        });
                    } else {
                        this.$refs.form.clearValidate();
                        this.$message.error('请补全信息')
                        return false;
                    }
                });
            };
        },
        // 确定下线
        stateData() {
            request.post('/goods/spell/edit', this.form).then(ret => {
                if (ret.code == 1) {
                    this.$message.success('操作成功');
                    this.loadData();
                    this.confirmVisible = false;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        // 拼团商品
        collageGoods(id) {
            this.$router.push({ path: '/activity-CollageGoods', query: { id: id } })
        },
        changeImg(val) {
            this.ImgSwiperVisible = val;
        },
        changetext(val) {
            this.text = val;
        },
    }
};
</script>

<style scoped>
.red {
    color: #ff0000;
}

.green {
    color: green;
}
.gray {
    margin-left: 100px;
}
.span_gray {
    font-size: 12px;
    color: gray;
}

/* 对话框样式 */

.dialog_box >>> .el-dialog__body {
    padding: 20px 30px 20px 60px;
}

.dialog_box >>> .el-dialog__header {
    padding: 30px 30px 10px;
}

.dialog_box .el-form-item--small.el-form-item {
    margin-bottom: 20px;
}
.dialog_box .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.dialog_box .avatar {
    font-size: 28px;
    width: 150px;
    height: 200px;
    line-height: 200px;
}

.dialog_box .up {
    margin-top: 10px;
    margin-bottom: -10px;
}

.dialog_box .el-button {
    margin-left: 20px;
}
.dialog_box >>> .el-textarea {
    width: 80%;
}
.dialog_box >>> .el-input--small .el-input__inner {
    width: 148%;
}
.dialog_box .el-button {
    margin-left: 140px;
}
</style>
